import React, { useState, useEffect } from 'react';
import { Users, UserPlus, Calendar, User, Clock, Share2, BookOpen, Scale, Home,  FileText, Shield, AlertTriangle, Lock, Eye, Smartphone, Phone, Building, TrendingUp } from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogPost4 = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] py-12 sm:py-20 mt-20">
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center text-white">
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-8">
            <BookOpen className="w-4 h-4 sm:w-6 sm:h-6" />
            <span className="text-white font-semibold text-sm sm:text-base">المدونة القانونية</span>
          </div>
          
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 leading-tight px-2 text-white">
            الأدلة الرقمية | ثورة جديدة في الإثبات القانوني
          </h1>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white text-sm sm:text-base">
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>ديسمبر 2025</span>
            </div>
            <div className="flex items-center gap-2">
              <User className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>شركة أنس للمحاماة</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>20 دقيقة قراءة</span>
            </div>
          </div>
        </div>
      </div>

      {/* Article Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden">
          
          {/* Article Header */}
          <div className="p-4 sm:p-8 border-b border-gray-100">
            <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <p className="text-sm sm:text-base md:text-lg text-[#0a3a23] font-semibold">
                <strong>إشراف: شركة أنس للمحاماة والاستشارات القانونية</strong>
              </p>
            </div>
          </div>

          {/* Introduction */}
          <div className="p-4 sm:p-8">
            <div className="mb-6 sm:mb-8">
              <img 
                src="/images/blog/Blog31.png" 
                alt="الأدلة الرقمية" 
                className="w-full h-48 sm:h-64 object-cover rounded-lg sm:rounded-xl mb-4 sm:mb-6"
              />
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                في السابق كان الإثبات أمام القضاء يعتمد بشكل أساسي على الشهود، أو الأوراق المكتوبة، أو الاعتراف المباشر، لكن مع التطور الهائل في التقنية تغيرت صورة الحياة اليومية، وأصبحت أغلب التعاملات بين الأطراف تتم عبر الأجهزة الإلكترونية، ومن هنا ظهرت الأدلة الرقمية كعنصر إثبات جديد وفعال في كافة القضايا والنزاعات.
              </p>
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                أصبحت الأدلة الرقمية اليوم من أهم وسائل الإثبات في القضايا المدنية والجنائية والتجارية، نظراً لاعتماد الأفراد والشركات على التقنية في تعاملاتهم اليومية، مما جعل من الهاتف أو البريد الإلكتروني شاهدًا قد يحسم نتيجة قضية بأكملها.
              </p>
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                في هذا المقال، نستعرض مفهوم الأدلة الرقمية، وأهميتها، وشروط قبولها، والتحديات التي تواجهها، وكيفية تقديمها للمحكمة.
              </p>
            </div>

            {/* Section 1 */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Shield className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">أولاً: ما هي الأدلة الرقمية؟</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
                <div>
                  <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                    الأدلة الرقمية هي كل أثر أو معلومة يتم استخراجها من جهاز إلكتروني أو شبكة اتصال، ويمكن استخدامها لإثبات أو نفي واقعة أمام القضاء. وتشمل على سبيل المثال الرسائل النصية عبر الهواتف، والمحادثات في تطبيقات التواصل الاجتماعي، والصور ومقاطع الفيديو، وبيانات الموقع الجغرافي، وتسجيلات الكاميرات الأمنية.
                  </p>
                </div>
                <div>
                  <img 
                    src="/images/blog/Blog33.png" 
                    alt="الأدلة الرقمية" 
                    className="w-full h-40 sm:h-48 object-cover rounded-lg sm:rounded-xl"
                  />
                </div>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-3 sm:mb-4">
                  تشمل الأدلة الرقمية أيضًا السجلات الإلكترونية للبنوك أو الشركات، وتطبيقات الذكاء الاصطناعي مثل شات جي بي تي، وكل ما يمكن استخراجه من الأجهزة الإلكترونية والشبكات الرقمية. هذه الأدلة أصبحت اليوم شاهدًا صامتًا يسجل الأحداث والوقائع بدقة وسرية.
                </p>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  تكمن أهمية الأدلة الرقمية في كونها تثبت وجود الجاني مكان الجريمة ووقت وقوعها، أو تكشف عمليات التحويل المالي، أو تثبت وجود رسائل التهديد والإساءة بين الأطراف.
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Building className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">ثانياً: شروط قبول الأدلة الرقمية</h2>
              </div>
              
              <img 
                src="/images/blog/Blog32.png" 
                alt="شروط قبول الأدلة الرقمية" 
                className="w-full h-48 sm:h-64 object-cover rounded-lg sm:rounded-xl mb-4 sm:mb-6"
              />
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                هناك شروط أساسية يجب توفرها لقبول الأدلة الرقمية أمام المحاكم، ومن أهم هذه الشروط:
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">سلامة الدليل الرقمي</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يجب أن يكون الدليل الرقمي سليماً من التلاعب أو العبث أو التحريف، وأن يكون صادراً من موظف عام أو شخص مكلف بخدمة عامة لينال حجية المحررات الرسمية.</p>
                </div>
                <div className="bg-[#0a3a23]/20 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">عدم المعارضة</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يجب ألا يعارض الدليل الرقمي دليل رقمي آخر بذات الدرجة من القوة، وأن يكون متوافقاً مع النظام العام.</p>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">تقديم الدليل بشكل صحيح</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يجب بيان نوع الدليل الرقمي ومضمونه، وتزويد المحكمة بنسخة منه، وتقديم محتواه مكتوباً إذا كانت طبيعته تسمح بذلك.</p>
                </div>
                <div className="bg-[#0a3a23]/20 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">الخبرة الفنية</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يمكن للمحكمة الاستعانة بخبير فني للتحقق من صحة الدليل الرقمي، وفقاً لأحكام نظام الإجراءات.</p>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <TrendingUp className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">ثالثاً: التحديات أمام الأدلة الرقمية</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
                <div>
                  <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                    رغم أن الأدلة الرقمية أصبحت اليوم من أهم وسائل الإثبات في القضايا المدنية والجنائية والتجارية، نظراً لاعتماد الأفراد والشركات على التقنية في تعاملاتهم اليومية، إلا أن هذه الأدلة تواجه العديد من التحديات التي قد تؤثر على قوتها القانونية ومصداقيتها أمام المحاكم.
                  </p>
                </div>
                <div>
                  <img 
                    src="/images/blog/Blog34.png" 
                    alt="تحديات الأدلة الرقمية" 
                    className="w-full h-40 sm:h-48 object-cover rounded-lg sm:rounded-xl"
                  />
                </div>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <h4 className="font-bold text-[#0a3a23] mb-3 sm:mb-4 text-sm sm:text-base">أبرز التحديات التي تواجه الأدلة الرقمية:</h4>
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>سهولة التلاعب:</strong> سهولة التلاعب بالصور والفيديوهات والملفات الصوتية باستخدام برامج متطورة وتقنيات الذكاء الاصطناعي.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>إمكانية الضياع:</strong> البيانات الإلكترونية معرضة للضياع أو الحذف سواء بشكل متعمد أو غير مقصود نتيجة أعطال فنية.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>الحاجة للخبراء:</strong> إثبات سلامة ومصداقية الأدلة الرقمية يتطلب وجود خبراء تقنيين متخصصين في مجال الأمن السيبراني.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span><strong>اختلاف الأنظمة القانونية:</strong> التباين بين الأنظمة القانونية في الدول بشأن قبول الأدلة الرقمية.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 4: كيفية تقديم الأدلة الرقمية للمحكمة */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <FileText className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">رابعاً: كيفية تقديم الأدلة الرقمية للمحكمة</h2>
              </div>
              
              <img 
                src="/images/صور الموقع (1)/14.jpg" 
                alt="تقديم الأدلة الرقمية للمحكمة" 
                className="w-full h-48 sm:h-64 object-cover rounded-lg sm:rounded-xl mb-4 sm:mb-6"
              />
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                يتطلب تقديم الأدلة الرقمية للمحكمة اتباع إجراءات محددة لضمان قبولها:
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">التوثيق الصحيح</h4>
                  <p className="text-sm sm:text-base text-gray-800">يجب توثيق الدليل الرقمي من خلال خبير تقني معتمد أو جهة رسمية مختصة.</p>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">النسخ الاحتياطية</h4>
                  <p className="text-sm sm:text-base text-gray-800">الاحتفاظ بنسخ احتياطية من الأدلة الرقمية في أماكن آمنة ومتعددة.</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">التقرير التقني</h4>
                  <p className="text-sm sm:text-base text-gray-800">إعداد تقرير تقني مفصل يوضح كيفية استخراج الدليل وضمان سلامته.</p>
                </div>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-gray-800 mb-2 sm:mb-3 text-sm sm:text-base">الشفافية الكاملة</h4>
                  <p className="text-sm sm:text-base text-gray-800">تقديم جميع المعلومات المتعلقة بالدليل الرقمي بشكل واضح وشفاف.</p>
                </div>
              </div>
            </div>

            {/* Section 5: مستقبل الأدلة الرقمية */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <TrendingUp className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">خامساً: مستقبل الأدلة الرقمية في النظام القانوني</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
                <div>
                  <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                    مع التطور المستمر في التكنولوجيا، يتوقع أن تصبح الأدلة الرقمية أكثر أهمية في النظام القانوني، خاصة مع انتشار الذكاء الاصطناعي وتقنيات البلوك تشين.
                  </p>
                  
                  <div className="space-y-2 sm:space-y-3">
                    <div className="flex items-start gap-2 sm:gap-3">
                      <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                      <span className="text-sm sm:text-base text-gray-800"><strong>التطوير المستمر:</strong> تطوير تقنيات أكثر تطوراً للتحقق من صحة الأدلة الرقمية.</span>
                    </div>
                    <div className="flex items-start gap-2 sm:gap-3">
                      <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                      <span className="text-sm sm:text-base text-gray-800"><strong>التشريعات الجديدة:</strong> إصدار تشريعات أكثر تفصيلاً لتنظيم الأدلة الرقمية.</span>
                    </div>
                  </div>
                </div>
                <div>
                  <img 
                    src="/images/blog/Blog31.png" 
                    alt="مستقبل الأدلة الرقمية" 
                    className="w-full h-48 sm:h-64 object-cover rounded-lg sm:rounded-xl"
                  />
                </div>
              </div>
            </div>

            {/* Conclusion */}
            <div className="mb-8 sm:mb-12">
              <div className="bg-[#0a3a23]/10 p-6 sm:p-8 rounded-xl sm:rounded-2xl">
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">خاتمة</h3>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  أصبحت الأدلة الرقمية اليوم جزءاً لا يتجزأ من النظام القانوني الحديث، وتلعب دوراً حاسماً في إثبات الحقوق والوقائع أمام المحاكم. إن فهم كيفية التعامل مع هذه الأدلة ومعايير قبولها أمر ضروري لكل من يعمل في المجال القانوني.
                </p>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  مع التطور المستمر في التكنولوجيا، من المهم أن نواكب هذه التطورات ونطور من قدراتنا في التعامل مع الأدلة الرقمية لضمان تحقيق العدالة وحماية الحقوق في العصر الرقمي.
                </p>
              </div>
            </div>

            {/* Call to Action */}
            <div className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] p-6 sm:p-8 rounded-xl sm:rounded-2xl text-white text-center">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4">هل تحتاج استشارة في الأدلة الرقمية؟</h3>
              <p className="text-white mb-4 sm:mb-6 text-sm sm:text-base">
                تواصل مع مكتب أنس للمحاماة للحصول على استشارة قانونية متخصصة في الأدلة الرقمية والإثبات القانوني
              </p>
              <button className="bg-white text-[#0a3a23] px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors text-sm sm:text-base">
                احجز استشارة الآن
              </button>
            </div>

            {/* Author Section */}
            <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#0a3a23]/10 to-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <div className="flex items-center">
                <p className="text-sm sm:text-base text-[#0a3a23] font-semibold">
                  <strong>إعداد: نهى عبد العزيز</strong>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Share Section */}
        <div className="mt-6 sm:mt-8 text-center">
          <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <Share2 className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600" />
            <span className="text-gray-600 font-semibold text-sm sm:text-base">شارك المقال</span>
          </div>
          <div className="flex justify-center gap-3 sm:gap-4">
            <a
              href="https://x.com/khayatlawfirm?t=jAXcLytECVDZ2DRxkSLPWg&s=09"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              تويتر
            </a>
            <a
              href="https://www.instagram.com/khayatlawfirm?igsh=MTRmNXByeDBnOGxucw=="
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              انستجرام
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/966115115945?text=أريد استشارة في الأدلة الرقمية"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      <Footer />
    </div>
  );
};

export default BlogPost4; 
